interface CrewCardProps {
  name: string;
  email: string;
  avatarUrl: string | null;
  /** Formatted membership number, e.g. `#0142`. Omit to leave the tag off. */
  crewNo?: string;
  roleLabel: string;
  rank: string;
  /** Primary craft, company need, or study track — whatever the role calls it. */
  discipline: string;
  percent: number;
}

/** The thing the induction is for: a credential with your number on it. */
export default function CrewCard({
  name,
  email,
  avatarUrl,
  crewNo,
  roleLabel,
  rank,
  discipline,
  percent
}: CrewCardProps) {
  return (
    <div className="crew">
      <div className="ch">
        {crewNo ? <span className="cno">Founding crew {crewNo}</span> : null}
        <span className="crole">{roleLabel}</span>
      </div>

      <div className="who">
        {avatarUrl ? (
          <img src={avatarUrl} alt="" width={52} height={52} referrerPolicy="no-referrer" />
        ) : (
          <span className="who-blank" aria-hidden="true">
            {name.slice(0, 1).toUpperCase()}
          </span>
        )}
        <div>
          <div className="n">{name}</div>
          <div className="e">{email}</div>
        </div>
      </div>

      <div className="cfoot">
        <div className="cf">
          <div className="k">Rank</div>
          <div className="v">{rank}</div>
        </div>
        <div className="cf">
          <div className="k">Discipline</div>
          <div className="v">{discipline}</div>
        </div>
        <div className="cf">
          <div className="k">Profile</div>
          <div className="v">{percent}% complete</div>
        </div>
      </div>
    </div>
  );
}
